/* eslint-disable */
const splitColon = (str) => {
    if(str.includes(':')) {
        const moduleArray = str.split(':');
        return moduleArray;
    }
};

const formatString = (str) => {
    const alwaysUppercase = ['mis', 'csat', 'pmo', 'agm', 'sgm', 'egm']; // add more as needed

    const formatWord = (word) => {
        if (word.toLowerCase() === 'rag') return 'RAG';
        return alwaysUppercase.includes(word.toLowerCase())
            ? word.toUpperCase()
            : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    };

    let accessModule = '';
    if (str.includes('-')) {
        accessModule = str
            .split('-')
            .map(formatWord)
            .join(' ');
    } else {
        accessModule = formatWord(str);
    }
    return accessModule;
}

export { splitColon, formatString };